import React from "react";
// import EditIcon from "@mui/icons-material/Edit";
// import ClearIcon from "@mui/icons-material/Clear";
// import PropTypes from "prop-types";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useAppContext } from "../../Lib/ContextLib";

import SweetAlert from "react-bootstrap-sweetalert";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";

export default function Withdraw() {
  const { showPage, setShowPage, accessObject } = useAppContext();

  const [alert, setAlert] = React.useState(null);
  const [isEdit, setIsEdit] = React.useState(false);
  const [tableData, setTableData] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  React.useEffect(() => {
    getBranch();
  }, []);
  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/withdraw/get-withdraw`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };
  const LoginSchema3 = Yup.object().shape({
    minWithdraw: Yup.string().required("required"),
    maxWithdraw: Yup.string().required("required"),
  });

  const successEdit = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setIsEdit(false);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The withdrawal settings have been updated successfully."}</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      <div class="content p-3 ">
        <div className="card p-3">
          {!loader && (
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  minWithdraw: tableData?.minWithdraw || 0,
                  maxWithdraw: tableData?.maxWithdraw || 0,
                }}
                validationSchema={LoginSchema3}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  let merged = { ...values, id: tableData?._id };
                  console.log("values", values);
                  axios(
                    `${API_URL}/api/admin/withdraw/update-withdraw/${tableData?._id}`,
                    {
                      method: "PATCH",
                      credentials: "include",
                      data: merged,
                    }
                  )
                    .then((result) => {
                      console.log("handleSubmit result :::", result.data);
                      setbuttonLoader(false);
                      successEdit(result.data.message);
                    })
                    .catch((err) => {
                      console.log("handleSubmit err :::", err);
                    });
                }}
              >
                {({ touched, errors, isSubmitting, values }) => (
                  <div className="p-2">
                    <Form>
                      <div className="row">
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Min Withdraw
                          </label>
                          <Field
                            type="number"
                            name="minWithdraw"
                            placeholder="Min Withdraw"
                            disabled={!accessObject?.editWithdraw}
                            className={`form-control ${
                              touched.minWithdraw && errors.minWithdraw ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="minWithdraw"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Max Withdraw
                          </label>
                          <Field
                            type="number"
                            name="maxWithdraw"
                            placeholder="Max Withdraw"
                            disabled={!accessObject?.editWithdraw}
                            className={`form-control ${
                              touched.maxWithdraw && errors.maxWithdraw ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="maxWithdraw"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      {accessObject?.editWithdraw == true && (
                        <div className="mt-2">
                          <button
                            type="submit"
                            className="btn btn-warning font-weight-bold px-4"
                            disabled={buttonLoader}
                            style={{
                              borderRadius: "8px",
                              border: "none",
                              height: "45px",
                              boxShadow: "0 4px 6px -1px rgba(255, 193, 7, 0.2)",
                              color: "#000"
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-center">
                              <span>Submit</span>
                              {buttonLoader && (
                                <div
                                  className="spinner-border spinner-border-sm ml-2"
                                  role="status"
                                ></div>
                              )}
                            </div>
                          </button>
                        </div>
                      )}
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          )}
          {loader && <Loader />}
        </div>
      </div>
    </>
  );
}
